import axios from 'axios';
import MyClaimFormPageActionTypes from './my-claim-form-page-action-types';
import ValidationError from '../../../utils/validation-error';

export const loadMyClaimFormPage = (claimId) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_START });
  if (claimId) {
    try {
      const claim = await api.get(`api/my_general_competency_claims/${claimId}`);
      dispatch({
        type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END,
        payload: {
          claim: {
            id: claim.id,
            title: claim.title,
            organizer: claim.organizer,
            occurredAt: claim.occurredAt ? new Date(claim.occurredAt.substring(0, 10) + 'T12:00:00') : null,
            minutes: claim.minutes,
            description: claim.description
          },
          attachmentId: claim.attachmentId || null,
          attachmentFilename: claim.attachmentFilename || null
        }
      });
    } catch (error) {
      dispatch({ type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END });
      throw error;
    }
  } else {
    dispatch({ type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END });
  }
};

export const uploadAttachment = (file) => async(dispatch, getState, { api }) => {
  dispatch({ type: MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_START });
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post('/api/attachments', formData, {
      headers: { ...axios.defaults.headers.common, 'Content-Type': 'multipart/form-data' }
    });
    dispatch({
      type: MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_END,
      payload: { attachmentId: response.data.id, attachmentFilename: response.data.filename }
    });
  } catch (error) {
    dispatch({
      type: MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_END,
      payload: { uploadError: error?.response?.data?.message || 'Upload failed' }
    });
  }
};

export const reportInvalidAttachment = (message) => (dispatch) => {
  dispatch({
    type: MyClaimFormPageActionTypes.UPLOAD_ATTACHMENT_END,
    payload: { uploadError: message }
  });
};

export const clearUploadError = () => (dispatch) => {
  dispatch({ type: MyClaimFormPageActionTypes.CLEAR_UPLOAD_ERROR });
};

export const cleanupMyClaimFormPage = () => (dispatch) => {
  dispatch({ type: MyClaimFormPageActionTypes.CLEANUP_MY_CLAIM_FORM_PAGE });
};

export const openDeleteAttachmentDialog = () => async(dispatch) => {
  dispatch({ type: MyClaimFormPageActionTypes.TOGGLE_DELETE_ATTACHMENT_DIALOG });
};

export const closeDeleteAttachmentDialog = () => async(dispatch) => {
  dispatch({ type: MyClaimFormPageActionTypes.TOGGLE_DELETE_ATTACHMENT_DIALOG });
};

export const confirmDeleteAttachment = () => async(dispatch, getState, { api }) => {
  const state = getState().myGeneralCompetencyClaimFormPage;
  if (state.attachmentId) {
    try {
      await api.remove(`api/attachments/${state.attachmentId}`);
    } catch (error) {
      // ignore — file may already be deleted
    }
  }
  dispatch({ type: MyClaimFormPageActionTypes.DELETE_ATTACHMENT_END });
};

export const saveMyClaim = (payload) => async(dispatch, getState, { api, history }) => {
  dispatch({ type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_START });
  try {
    const data = {
      title: payload.title,
      organizer: payload.organizer,
      occurredAt: payload.occurredAt,
      minutes: payload.minutes,
      description: payload.description || null,
      attachmentId: payload.attachmentId || null
    };
    if (payload.id) {
      await api.put(`api/my_general_competency_claims/${payload.id}`, data);
    } else {
      await api.post('api/my_general_competency_claims', data);
    }
    dispatch({ type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END });
    history.back();
  } catch (error) {
    let validationResult = null;
    if (error instanceof ValidationError) {
      validationResult = {
        errorMessage: error.message,
        errors: error.errors
      };
    }
    dispatch({
      type: MyClaimFormPageActionTypes.LOAD_MY_CLAIM_FORM_PAGE_END,
      payload: { validationResult }
    });
  }
};
